/**
 * @generated SignedSource<<1f74a5836cf333e34a3b589bcb62cb6c>>
 * @relayHash fe5341c7119ce6b48784ed36451a3ad5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 92726285efdd6e37384c9e6e8ed615f4bed51619568bbfa43f845a7fbf98b969

import type { ConcreteRequest } from 'relay-runtime';
export type SpaceRoleType = "CUSTOM" | "SYSTEM" | "%future added value";
export type useViewPermissionsModalRolesQuery$variables = Record<PropertyKey, never>;
export type useViewPermissionsModalRolesQuery$data = {
  readonly spaceRolesByCriteria: {
    readonly nodes: ReadonlyArray<{
      readonly roleDescription: string;
      readonly roleDisplayName: string;
      readonly roleId: string;
      readonly roleType: SpaceRoleType;
      readonly spacePermissionList: ReadonlyArray<{
        readonly description: string | null;
        readonly displayName: string;
        readonly hubDescription: string | null;
        readonly hubDisplayName: string | null;
        readonly id: string;
        readonly priority: number;
        readonly requiredSpacePermissions: ReadonlyArray<string | null> | null;
      }>;
    } | null>;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
  } | null;
};
export type useViewPermissionsModalRolesQuery = {
  response: useViewPermissionsModalRolesQuery$data;
  variables: useViewPermissionsModalRolesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "SpaceRoleConnection",
    "kind": "LinkedField",
    "name": "spaceRolesByCriteria",
    "plural": false,
    "selections": [
      {
        "concreteType": "SpaceRole",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "roleId"
          },
          {
            "kind": "ScalarField",
            "name": "roleDisplayName"
          },
          {
            "kind": "ScalarField",
            "name": "roleDescription"
          },
          {
            "kind": "ScalarField",
            "name": "roleType"
          },
          {
            "concreteType": "SpacePermissionInfo",
            "kind": "LinkedField",
            "name": "spacePermissionList",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "priority"
              },
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "kind": "ScalarField",
                "name": "hubDisplayName"
              },
              {
                "kind": "ScalarField",
                "name": "hubDescription"
              },
              {
                "kind": "ScalarField",
                "name": "requiredSpacePermissions"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "SpaceRolePageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "endCursor"
          },
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewPermissionsModalRolesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useViewPermissionsModalRolesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "fe5341c7119ce6b48784ed36451a3ad5",
    "id": "92726285efdd6e37384c9e6e8ed615f4bed51619568bbfa43f845a7fbf98b969",
    "metadata": {},
    "name": "useViewPermissionsModalRolesQuery",
    "operationKind": "query",
    "text": "query useViewPermissionsModalRolesQuery{spaceRolesByCriteria{nodes{roleId,roleDisplayName,roleDescription,roleType,spacePermissionList{id,priority,displayName,description,hubDisplayName,hubDescription,requiredSpacePermissions}},pageInfo{endCursor,hasNextPage}}}"
  }
};
})();

(node as any).hash = "0d3baeae35295e4523feb5527dc2a3d3";

export default node;
